import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { switchMap, take, filter, map, withLatestFrom } from 'rxjs/operators';
import { IResponseSuccess } from '@core/interfaces';
import { Store as StoreModel, Tip, TipDetail } from '@core/models';
import { Store } from '@ngrx/store';
import { selectStore } from '@store/selectors';
import { selectTip, selectTipDetail } from '@store/selectors/tip.selectors';
import { IntegerPrecisionService } from '../integer-precision/integer-precision.service';

@Injectable({
	providedIn: 'root',
})
export class TipService {
	store$: Observable<StoreModel | null>;
	tip: Observable<Tip | null>;

	constructor(
		private http: HttpClient,
		private store: Store,
		private integerPrecisionService: IntegerPrecisionService
	) {
		this.store$ = this.store.select(selectStore);
		this.tip = this.store.select(selectTip);
	}

	find(localChannelId: string | null): Observable<IResponseSuccess<Tip>> {
		return this.store$.pipe(
			filter((store): store is StoreModel => !!store),
			filter(() => !!localChannelId),
			switchMap(store => {
				return this.http.get<IResponseSuccess<Tip>>(`${environment.microConfiguraciones}/propina`, {
					params: {
						localId: store.idLocal,
						useLocalCanalId: localChannelId as string,
					},
					headers: {
						authorization: store.apiKey,
					},
				});
			}),
			take(1)
		);
	}

	getTipDeatils(): Observable<TipDetail[]> {
		return this.tip.pipe(
			withLatestFrom(this.store.select(selectTipDetail)),
			map(([tip, selectedTip]) => {
				return (tip?.detallesPropinas ?? []).map(tip => {
					const calcPercent = this.integerPrecisionService.toDecimalNumberFromInternal(tip.valor);
					return {
						...tip,
						percent: calcPercent,
						selected: tip.descripcion === selectedTip?.descripcion,
					};
				});
			})
		);
	}
}
